export default __webpack_public_path__ + "5694dc72647b0b6ec85f921e54abbb77.png";